import React from 'react';
import { withTrans } from "@i18n/withTrans";

import { LogoPage } from './LogoPage';
import { LogoPageInverse } from './LogoPageInverse';
import { LogoClearspace } from './LogoClearspace';
import { PetalIcon } from './PetalIcon';
import { IncorrectLogo } from './IncorrectLogo';
import { FlexDiv, Page } from '@Main/elements';
import { PageNavigation, Margin } from '@helpers';

import { useStaticQuery, graphql } from "gatsby";

export const Logo = ({t, i18n}) => {
    i18n.loadNamespaces('logo');

    const pages = [
        {
            title: 'Logo',
            component: LogoPage,
        },
        {
            title: 'Logo color inversion',
            component: LogoPageInverse,
        },
        {
            title: 'Logo clearspace',
            component: LogoClearspace,
        },
        {
            title: 'Petal icon clearspace',
            component: PetalIcon,
        },
        {
            title: 'Incorrect logo reproduction',
            component: IncorrectLogo,
        },
    ];

    const data = useStaticQuery(graphql`
        {
            images: allFile(filter: {relativeDirectory: {eq: "logo"}, extension: {eq: "png"}}) {
                edges {
                    node {
                        childImageSharp {
                            gatsbyImageData(width: 800, placeholder: DOMINANT_COLOR, formats: NO_CHANGE)
                        }
                        name
                        publicURL
                        relativePath,
                        extension
                    }
                }
            },
            zips: allFile(filter: {relativeDirectory: {eq: "logo"}, extension: {eq: "zip"}}) {
                edges {
                    node {
                        name
                        publicURL
                        relativePath,
                        extension
                    }
                }
            }
        }
    `)

    const getPng = (fileName) => {
        const file = data.images.edges.filter(edge => edge.node.name === fileName)[0];

        return file.node;
    }

    const getZip = (fileName) => {
        const file = data.zips.edges.filter(edge => edge.node.name === fileName)[0];

        return file.node.publicURL;
    }
    
    return (
        <Page>
            <PageNavigation t={t} onThisPage={pages.map(page => t(`logo>${page.title}`))}/>
            <FlexDiv direction="column">
                { 
                    pages.map((page, index) => 
                        <Margin id={`block-${index + 1}`} key={page.title} marginTop={index && '50px'}>
                            {
                                React.createElement(page.component, {
                                        key: index,
                                        getPng: getPng,
                                        getZip: getZip,
                                        t: (text) => t(`logo>${text}`)
                                })
                            }
                        </Margin>
                    )
                }
            </FlexDiv>
        </Page>
    );
};

export const LogoContainer = withTrans(Logo);